import type { SVGProps } from 'react';
const DawnFlagRS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-RS_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-RS_svg__a)">
      <path
        fill="#17508F"
        fillRule="evenodd"
        d="M0 10.667h22V5.333H0z"
        clipRule="evenodd"
      />
      <path fill="#E1444D" fillRule="evenodd" d="M0 5.333h22V0H0z" clipRule="evenodd" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M4.714 8c0-.489.242-1.546.397-2.172a.654.654 0 0 1 .638-.495H7.87c.3 0 .564.201.637.493.155.623.396 1.674.396 2.174 0 .585-.378 2.103-.492 2.544a.6.6 0 0 1-.11.222c-.218.265-.855.967-1.493.967s-1.276-.703-1.493-.968a.6.6 0 0 1-.11-.22C5.092 10.107 4.714 8.6 4.714 8"
        clipRule="evenodd"
      />
      <mask
        id="dawn-flag-RS_svg__b"
        width={5}
        height={7}
        x={4}
        y={5}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M4.714 8c0-.489.242-1.546.397-2.172a.654.654 0 0 1 .638-.495H7.87c.3 0 .564.201.637.493.155.623.396 1.674.396 2.174 0 .585-.378 2.103-.492 2.544a.6.6 0 0 1-.11.222c-.218.265-.855.967-1.493.967s-1.276-.703-1.493-.968a.6.6 0 0 1-.11-.22C5.092 10.107 4.714 8.6 4.714 8"
          clipRule="evenodd"
        />
      </mask>
      <g
        stroke="#E1444D"
        strokeLinecap="square"
        strokeWidth={1.333}
        mask="url(#dawn-flag-RS_svg__b)"
      >
        <path d="M8.905 5.867 4.715 11.2M4.713 5.867l4.19 5.333" />
      </g>
    </g>
  </svg>
);
export default DawnFlagRS;
